import { FC } from 'react'
import { UserCard, UserCardProps } from '../UserCard'
import { useSelector } from 'react-redux'
import { userSlice } from '../../slices/userSlice'

export const CurrentUserCard: FC<
  Pick<
    UserCardProps,
    'onlyAvatar' | 'avatarClassName' | 'className' | 'userTextClassname'
  >
> = ({ onlyAvatar, avatarClassName, className, userTextClassname }) => {
  const user = useSelector(userSlice.selectors.selectCurrentUser)

  if (!user) return null

  const { displayName, username } = user
  return (
    <UserCard
      avatarClassName={avatarClassName}
      displayName={displayName}
      username={username}
      imgUrl={user.avatar?.files[0]?.uri || undefined}
      onlyAvatar={onlyAvatar}
      className={className}
      userTextClassname={userTextClassname}
    />
  )
}
